import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface IRouteProviderProps {
    location: string;
    loginLocation?: boolean;
}

const RouteContext = createContext<IRouteProviderProps>({ location: "" });

export const RouteProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const location = useLocation();
    const [currentRoute, setCurrentRoute] = useState(location.pathname);

    useEffect(() => {
        setCurrentRoute(location.pathname);
    }, [location]);

    return (
        <RouteContext.Provider value={{ location: currentRoute, loginLocation: window.location.pathname === "/login" }}>
            {children}
        </RouteContext.Provider>
    );
};

export const useCurrentRoute = () => useContext(RouteContext);